/*
 * Author M. Atoar Rahman
 * Title: Facility Stock Return
 * Description: Page for Facility Stock Return
 * Date: 19/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { StockReturnApprovalProvider } from '../partner/facilityStockReturnReceive/ContextAPI';
import Index from '../partner/facilityStockReturnReceive/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityStockReturnReceive() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-stock-return-receive']) return <PermissionDenied />;

    return (
        <StockReturnApprovalProvider>
            <Index />
        </StockReturnApprovalProvider>
    );
}
